import useGlobalContext from "hooks/globalData";
import { Navigate } from "react-router-dom";

export default function CourseCatalog() {
  const { liveOnlineCatalogUrl } = useGlobalContext();
  return <Navigate to={liveOnlineCatalogUrl()} />;
}
